import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Document2Icon, ClockIcon, ImageIcon } from 'assets/icons';
import LoadingAnimation from 'assets/animations/loading.lottie';

const LottieAnimation = DotLottieReact as unknown as React.FC<{
  src: string;
  loop?: boolean;
  autoplay?: boolean;
  style?: React.CSSProperties;
}>;

interface FileUploadPlaceholderProps {
  isImage?: boolean;
}

const FileUploadPlaceholder = ({ isImage = false }: FileUploadPlaceholderProps) => {
  return (
    <div
      style={{
        position: 'relative',
        alignSelf: 'flex-end',
        minWidth: '25%',
        maxWidth: '60%',
        marginBottom: '10px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        className='link-file self uploading'
        style={{
          alignSelf: 'unset',
          minWidth: 'unset',
          maxWidth: 'unset',
          marginBottom: 0,
          flex: 1,
        }}
      >
        <img src={isImage ? ImageIcon : Document2Icon} />
        <p>Enviando Archivo...</p>
        <img src={ClockIcon} className='clock-icon' alt='Enviando' />
      </div>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '10px',
          backgroundColor: 'rgba(0, 0, 0, 0.15)',
        }}
      >
        {/* Se comenta temporalmente la animación Lottie de carga; se reemplaza
            por el ícono de reloj (ver <img className="clock-icon" /> arriba)
            para mantener consistencia visual con el resto del chat. */}
        {/* <LottieAnimation
          src={LoadingAnimation}
          loop
          autoplay
          style={{ width: 150, height: 150 }}
        /> */}
      </div>
    </div>
  );
};

export default FileUploadPlaceholder;
